import { Component,OnInit,AfterViewInit } from "@angular/core";
import { takeWhile } from "rxjs/operators";
import { trigger, style, animate, transition, state } from '@angular/animations';

import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsApiDtgCarService
    ,FvmsMainCarService
    ,FvmsMapApiProvidor
} from "src/app/shared/service";
import {
    PagingInfo
} from "src/app/shared/vo";
import {
    FilterCarStatus
    ,FilterCarStatusTimeLimit
    ,FilterCarTeam
    ,FilterCarSearch
    ,FilterDist
    ,FilterSecToTime
    ,FilterCarStatusTrans
} from "src/app/shared/filter";

@Component({
    selector: "[sidebar-ext-car-list]"
    ,templateUrl: "./sidebar.ext.car.list.component.html"
    ,providers: [
        FilterCarStatus
        ,FilterCarStatusTimeLimit
        ,FilterCarTeam
        ,FilterCarSearch
        ,FilterDist
        ,FilterSecToTime
        ,FilterCarStatusTrans
    ]
    ,animations: [
        trigger('listAnimation', [
            state('true', style({ opacity: 1 }))
            ,state('false', style({ opacity: 0 }))
            ,transition('true => false', animate('600ms'))
            ,transition('false => true', animate('300ms'))
        ])
    ]
})
export class SidebarExtCarListComponent implements OnInit,AfterViewInit {
    isContinue:boolean = true;
    currentUserInfo:any;
    companyInfo:any;
    searchValue:string;
    selectedStatus:any = "all";
    selectedTeamId:string = null;
    selectedCar:any;
    carCnt:any = {
        all:0
        ,on:0
        ,off:0
        ,error:0
    };
    pagingInfo:PagingInfo = new PagingInfo();
    mapService:any;
    listCarInfo:any[] = [];
    listCarInfoFilterdStatus:any[] = [];
    listTeamInfo:any[] = [];

    constructor(
        private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsCommonService: FvmsCommonService
        ,private fvmsApiDtgCarService:FvmsApiDtgCarService
        ,private filterCarStatusTimeLimit:FilterCarStatusTimeLimit
        ,private filterCarStatus:FilterCarStatus
        ,private filterCarTeam:FilterCarTeam
        ,private filterCarSearch:FilterCarSearch
        ,private fvmsMapApiProvidor:FvmsMapApiProvidor
        ,private fvmsMainCarService:FvmsMainCarService
    ){
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.pagingInfo.pageSize = 99999;
        this.mapService = this.fvmsMapApiProvidor.getMapApiService();
    }

    ngOnInit(){
        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                this.selectedStatus = "all";
                this.selectedTeamId = null;
                this.selectedCar = null;
                this.reloadListCar().then(() => {
                    this.createListTeam(this.listCarInfo);
                    this.calcCarCnt();
                    this.calcCarCntByTeamFilteredStatus();
                    let eveObj = {
                        evtCode:"sidebar.init.car"
                        ,selectedStatus:this.selectedStatus
                        ,selectedTeamId:this.selectedTeamId
                        ,selectedCar:this.selectedCar
                        ,listCar:this.listCarInfoFilterdStatus
                    };
                    this.fvmsMainCarService.subjCarFromSidebar.next(eveObj);
                });
            });

        this.fvmsMainCarService.subjCarFromMainMap
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(evtObj => {
                switch(evtObj.evtCode){
                    case "map.select.car.item":
                        this.changeSelectCarInfo(evtObj.selectedCar);
                        break;
                    case "map.auto.reload.car":
                        this.selectedStatus = "all";
                        this.selectedTeamId = null;
                        this.selectedCar = null;
                        this.reloadListCar().then(() => {
                            this.createListTeam(this.listCarInfo);
                            this.calcCarCnt();
                            this.calcCarCntByTeamFilteredStatus();
                            let eveObj = {
                                evtCode:"sidebar.auto.reload.car"
                                ,selectedStatus:this.selectedStatus
                                ,selectedTeamId:this.selectedTeamId
                                ,selectedCar:this.selectedCar
                                ,listCar:this.listCarInfoFilterdStatus
                            };
                            this.fvmsMainCarService.subjCarFromSidebar.next(eveObj);
                        });
                        break;
                    default:
                        break;
                }
            });

        this.selectedStatus = "all";
        this.selectedTeamId = null;
        this.selectedCar = null;
        this.reloadListCar().then(() => {
            this.createListTeam(this.listCarInfo);
            this.calcCarCnt();
            this.calcCarCntByTeamFilteredStatus();
            let eveObj = {
                evtCode:"sidebar.init.car"
                ,selectedStatus:this.selectedStatus
                ,selectedTeamId:this.selectedTeamId
                ,selectedCar:this.selectedCar
                ,listCar:this.listCarInfoFilterdStatus
            };
            this.fvmsMainCarService.subjCarFromSidebar.next(eveObj);
        });
    }

    ngAfterViewInit(){}

    reloadListCar(){
        this.fvmsCommonService.setIsLoading(true);
        let promise = new Promise<void>((resolve,reject) => {
            let companyId = this.companyInfo?.companyId || 0;
            let teamId = this.currentUserInfo.teamId || "";
            this.fvmsApiDtgCarService.getListStatus(companyId,null,null,teamId,this.searchValue,this.pagingInfo)
                .pipe(takeWhile(() => this.isContinue))
                .subscribe(response => {
                    if(response.resultStatus === "ok"){
                        if(response.resultValue){
                            this.listCarInfo = this.filterCarStatusTimeLimit.transform(response.resultValue,4);
                            this.listCarInfoFilterdStatus = this.filterCarStatusTimeLimit.transform(this.listCarInfo,4);
                            this.fvmsCommonService.setIsLoading(false);
                            resolve();
                        }
                        resolve();
                    }
                    resolve();
                },err => {
                    console.error("reloadListCar",err);
                    this.fvmsCommonService.setIsLoading(false);
                    resolve();
                },() => {
                    this.fvmsCommonService.setIsLoading(false);
                    resolve();
                });
        });
        return promise;
    }

    // 그룹 정보만 추출
    createListTeam(listCarInfo){
        if(!listCarInfo){
            return null;
        }
        let mapTeamInfo = [];
        let sizeListCar = listCarInfo.length;
        for(let a=0;a<sizeListCar;a++){
            let itemCar = listCarInfo[a];
            if(this.checkLatLng(itemCar) === false){
                itemCar.dtgGpsLat = 37.5665846;
                itemCar.dtgGpsLng = 126.9783272;
                itemCar.dtgGpsGeoHash = "wydm9qyc";
            }
            let teamId = itemCar.dtgTeamId;
            let itemTeam = mapTeamInfo[teamId];
            if(!itemTeam){
                let teamInfo = {
                    dtgTeamId:teamId
                    ,dtgTeamNm:itemCar.dtgTeamNm
                    ,isOpen:false
                    ,cntCar:1
                    ,cntCarStatus:1
                };
                mapTeamInfo[teamId] = teamInfo;
            }else{
                itemTeam.cntCar = itemTeam.cntCar + 1;
                itemTeam.cntCarStatus = itemTeam.cntCarStatus + 1;
            }
        }
        if(mapTeamInfo){
            this.listTeamInfo = [];
            let listKey = Object.keys(mapTeamInfo);
            let sizeKey = listKey.length;
            for(let a=0;a<sizeKey;a++){
                let itemKey = listKey[a];
                this.listTeamInfo.push(mapTeamInfo[itemKey]);
            }
        }
    }

    // 차량 상태별 차량수 초기화
    initCarCnt(){
        this.carCnt = {
            all:0
            ,on:0
            ,off:0
            ,error:0
        };
    }

    // 차량 상태별 차량수 계산
    calcCarCnt(){
        this.initCarCnt();
        if(this.listCarInfo){
            this.carCnt.all = this.listCarInfo.length;

            // 오류 없는 차량 목록
            let listFilteredByNoErr = this.filterCarStatus.transform(this.listCarInfo,"error",true);//error 만 빼고 다 가져와라
            if(listFilteredByNoErr){
                // 오류차량수 = 전체 - 오류 없는 차량
                this.carCnt.error = this.carCnt.all - listFilteredByNoErr.length;
            }

            // 오류 없는 차량 중 keyon 차량
            let listFilteredByOn = this.filterCarStatus.transform(listFilteredByNoErr,"on",false);//on 인것만 추출해라
            if(listFilteredByOn){
                this.carCnt.on = listFilteredByOn.length;
                // off = 오류 없는 차량 - on
                this.carCnt.off = listFilteredByNoErr.length - this.carCnt.on;
            }
        }
    }

    // 그룹별 차량수 계산 (상태별로 달라진다)
    calcCarCntByTeamFilteredStatus(){
        if(!this.listCarInfo){
            return;
        }
        if(!this.listTeamInfo){
            return;
        }

        let sizeListTeam = this.listTeamInfo.length;
        for(let a=0;a<sizeListTeam;a++){
            let itemTeam = this.listTeamInfo[a];
            switch(this.selectedStatus){
                case "all":
                    if(this.searchValue){
                        let listFilteredByTeam = this.filterCarTeam.transform(this.listCarInfoFilterdStatus,itemTeam.dtgTeamId);
                        if(!listFilteredByTeam){
                            continue;
                        }
                        itemTeam.cntCarStatus = listFilteredByTeam.length;
                    }else{
                        itemTeam.cntCarStatus = itemTeam.cntCar;
                    }
                    break;
                default:
                    let listFilteredByTeam = this.filterCarTeam.transform(this.listCarInfoFilterdStatus,itemTeam.dtgTeamId);
                    if(!listFilteredByTeam){
                        continue;
                    }
                    itemTeam.cntCarStatus = listFilteredByTeam.length;
                    break;
            }
        }
    }

    // 차량검색
    clickSearch(){
        if(!this.listCarInfo){
            return;
        }
        this.selectedTeamId = null;
        this.selectedCar = null;
        this.closeAllTeam();
        let listFilterd = this.filterCarSearch.transform(this.listCarInfo,this.searchValue);
        this.listCarInfoFilterdStatus = this.filterCarStatus.transform(listFilterd,this.selectedStatus,false);
        this.calcCarCntByTeamFilteredStatus();
        let eveObj = {
            evtCode:"sidebar.search.car"
            ,selectedStatus:this.selectedStatus
            ,selectedTeamId:this.selectedTeamId
            ,selectedCar:this.selectedCar
            ,listCar:this.listCarInfoFilterdStatus
        };
        this.fvmsMainCarService.subjCarFromSidebar.next(eveObj);
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.clickSearch();
    }

    // 상태 선택
    clickSelectStatus(status){
        this.selectedStatus = status;
        this.selectedTeamId = null;
        this.selectedCar = null;
        // 그룹 정보를 초기화
        this.closeAllTeam();
        let listFilterd = this.filterCarSearch.transform(this.listCarInfo,this.searchValue);
        this.listCarInfoFilterdStatus = this.filterCarStatus.transform(listFilterd,this.selectedStatus,false);
        this.calcCarCntByTeamFilteredStatus();
        let eveObj = {
            evtCode:"sidebar.select.car.status"
            ,selectedStatus:this.selectedStatus
            ,selectedTeamId:this.selectedTeamId
            ,selectedCar:this.selectedCar
            ,listCar:this.listCarInfoFilterdStatus
        };
        this.fvmsMainCarService.subjCarFromSidebar.next(eveObj);
    }

    // 모든 그룹 선택을 해제
    closeAllTeam(){
        if(!this.listTeamInfo){
            return;
        }
        let sizeList = this.listTeamInfo.length;
        for(let a=0;a<sizeList;a++){
            let itemTeam = this.listTeamInfo[a];
            itemTeam.isOpen = false;
        }
    }

    // 그룹 선택
    clickTeamInfo(dtgTeamId:string,idx:number,forceOpen:boolean,evtCode:string){
        this.closeAllTeam();
        this.selectedTeamId = dtgTeamId;
        let listCarInfoFilteredTeam = this.filterCarTeam.transform(this.listCarInfoFilterdStatus,dtgTeamId);
        let eveObj = {
            evtCode:"sidebar.select.car.team"
            ,selectedStatus:this.selectedStatus
            ,selectedTeamId:this.selectedTeamId
            ,selectedCar:this.selectedCar
            ,listCar:listCarInfoFilteredTeam
        };
        this.fvmsMainCarService.subjCarFromSidebar.next(eveObj);
    }

    // 그룹 선택 해제 클릭
    unselectTeamInfo(dtgTeamId:string,idx:number,forceOpen:boolean,evtCode:string){
        this.closeAllTeam();
        this.selectedTeamId = null;
        let eveObj = {
            evtCode:"sidebar.unselect.car.team"
            ,selectedStatus:this.selectedStatus
            ,selectedTeamId:this.selectedTeamId
            ,selectedCar:this.selectedCar
            ,listCar:this.listCarInfoFilterdStatus
        };
        this.fvmsMainCarService.subjCarFromSidebar.next(eveObj);
    }

    // 좌표를 표시할 수 없어서 마커를 출력할 수 없다
    checkLatLng(carInfo:any):boolean{
        return this.mapService.checkLatLng(carInfo.dtgGpsLat,carInfo.dtgGpsLng);
    }

    // 차량 정보 카드 선택
    clickCarInfo(carInfo:any){
        this.selectedCar = carInfo;
        let eveObj = {
            evtCode:"sidebar.select.car.item"
            ,selectedStatus:this.selectedStatus
            ,selectedTeamId:this.selectedTeamId
            ,selectedCar:this.selectedCar
            ,listCar:[this.selectedCar]
        };
        this.fvmsMainCarService.subjCarFromSidebar.next(eveObj);
    }

    // 차량 정보 카드 선택 해제
    unselectCarInfo(carInfo:any){
        this.closeAllTeam();
        this.selectedTeamId = null;
        this.selectedCar = null;
        let eveObj = {
            evtCode:"sidebar.unselect.car.item"
            ,selectedStatus:this.selectedStatus
            ,selectedTeamId:this.selectedTeamId
            ,selectedCar:this.selectedCar
            ,listCar:this.listCarInfoFilterdStatus
        };
        this.fvmsMainCarService.subjCarFromSidebar.next(eveObj);
    }

    // 지도에서 차량 선택시
    changeSelectCarInfo(carInfo:any){
        this.selectedCar = carInfo;
        this.selectedTeamId = carInfo.dtgTeamId;
    }
}